var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.paramsValue)?_c('vs-chip',{staticClass:"ag-grid-cell-chip",attrs:{"color":_vm.chipColorByType}},[_c('feather-icon',{attrs:{"icon":_vm.chipIconByType,"svgClasses":"h-5 w-5 mr-1"}}),_c('span',[_c('a',{class:[
            `text-dark`,
            !this.chipIsClickable ? 'pointer-events-none' : ''
          ],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onStatusClicked()}}},[_vm._v(" "+_vm._s(_vm.statusText)+" ")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }